// @flow

import React, {Fragment, useEffect} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import {showNotification} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';
import {colors} from 'js-libs/sweetcommons/styles';

const StyledContainerDiv = styled.div`
  background: ${colors.lightBg};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

type OwnProps = {
  error?: Error,
  toggleDiagram?: () => void,
};

type DispatchProps = {|
  showNotification: (string, level?: string) => any,
|};

type Props = {
  ...$Exact<OwnProps>,
  ...DispatchProps,
};

const BaseLoadingBaseDiagram = ({
  error,
  toggleDiagram,
  showNotification,
}: Props) => {
  useEffect(() => {
    if (error != null) {
      if (toggleDiagram != null) {
        toggleDiagram();
      }

      showNotification(
        gt('Could not open procedure overview. Please try again later.'),
        'danger'
      );
    }
  }, [error]);

  return (
    <StyledContainerDiv className="d-flex align-items-center justify-content-center">
      <h4 className="text-muted">
        {error != null ? (
          <Fragment>
            <i className="far fa-exclamation-triangle" />{' '}
            {gt('Error Loading overview')}
          </Fragment>
        ) : (
          <Fragment>
            <i className="fa fa-circle-notch fa-spin" />{' '}
            {gt('Loading overview')}...
          </Fragment>
        )}
      </h4>
    </StyledContainerDiv>
  );
};

export const LoadingBaseDiagram = connect<
  Props,
  OwnProps,
  _,
  DispatchProps,
  _,
  _
>(
  // $FlowFixMe - redux-thunk messes up with actions return types
  null,
  {showNotification}
)(BaseLoadingBaseDiagram);
